<div class="content-label-container">
    <h1 [style.color]="titleColor" translate>navigation.scholarship</h1>
    <p translate>scholarship.subtitle</p>
</div>

<div class="content-main-container">
    <div *ngFor="let i of items" class="contents">
        <h3>
            <a [href]="i.pdf" target="_blank" rel="noopener noreferrer">
                <mat-icon>picture_as_pdf</mat-icon>{{ i.name | translate}}
            </a>
        </h3>
        <a [href]="i.url" target="_blank" rel="noopener noreferrer">
            <span>
                {{ i.sub | translate}}
                <mat-icon>open_in_new</mat-icon>
                <br>
                <span translate>scholarship.provider</span>
            </span>
        </a>
    </div>

    <div class="attension">
        <h3 translate>scholarship.attension</h3>
    </div>
</div>